<template>
  <section class="returns-index">
    <returns-list-filter />

    <returns-list-filters
      v-if="filtering"
      class="returns-list-filters"
      @change="filterReturnRules"
    />

    <ul ref="scroller">
      <commercial-list
        key="commercial-list"
        :items="items"
        :rules="financingReturnRules"
        :actions="actions"
      />
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import {
    parsePreferenceLabels,
    findFilters,
    findQueryParams,
  } from '@/views/Settings/Commercial/Form/helpers';

  import { INITIAL_RETURN_FILTERS } from '@/store/modules/financing-return-rules';

  import CommercialListButton from '@/views/Settings/Commercial/List/Button.vue';
  import CommercialList from '@/views/Settings/Commercial/List.vue';
  import ReturnsListFilter from '@/views/Settings/Commercial/Returns/List/Filter.vue';
  import ReturnsListFilters from '@/views/Settings/Commercial/Returns/List/Filters.vue';

  export default {
    name: 'ReturnsIndex',
    components: {
      CommercialList,
      ReturnsListFilter,
      ReturnsListFilters,
    },
    data() {
      return {
        nav: {
          action: CommercialListButton,
        },
        items: [{
          id: 'minReturn',
          label: 'Retorno mínimo',
          field: 'min_return',
        }, {
          id: 'maxReturn',
          label: 'Retorno máximo',
          field: 'max_return',
        }, {
          id: 'returnPreference',
          label: 'Retorno prioritário',
          field: 'return_preference',
          formatter: parsePreferenceLabels,
        }, {
          id: 'quotaPreference',
          label: 'Parcela prioritária',
          field: 'quota_preference',
          formatter: parsePreferenceLabels,
        }],
        actions: {
          update: 'settings-commercial-returns-update',
          delete: 'financingReturnRules/delete',
        },
        limit: false,
        count: 0,
      };
    },
    computed: {
      ...mapState([
        'financingReturnRules',
      ]),

      filtering() {
        return this.financingReturnRules.list.filters.active;
      },
    },
    mounted() {
      this.initialFilter();
      window.addEventListener('scroll', this.scrollReturnRules, { passive: true });
    },
    beforeDestroy() {
      this.clearReturnRules();
      window.removeEventListener('scroll', this.scrollReturnRules, { passive: true });
    },

    methods: {
      initialFilter() {
        let foundFilters = {};
        const { page, ...queryParameters } = this.$route.query;

        if (queryParameters) {
          foundFilters = findFilters(queryParameters, INITIAL_RETURN_FILTERS);
        }

        if (page) {
          foundFilters.page = 1; // parseInt(page, 10);
        }

        this.fetchReturnRules(foundFilters);
      },

      getReturnRules() {
        const {
          filters,
          items,
        } = this.financingReturnRules.list;

        this.updateQuery();
        this.count = Object.keys(items).length;

        this.$store
          .dispatch('financingReturnRules/list', filters)
          .then(this.gotReturnRules);
      },
      gotReturnRules() {
        const {
          items,
        } = this.financingReturnRules.list;

        const count = Object.keys(items).length;

        if (this.count === count) {
          this.limit = true;
        } else {
          this.count = count;
        }
      },

      clearReturnRules() {
        this.$store.dispatch('financingReturnRules/clear', { action: 'list' });
      },

      filterReturnRules(params) {
        this.clearReturnRules();

        this.fetchReturnRules({
          ...params,
          page: 1,
        });
      },

      fetchReturnRules(params) {
        this.$store
          .dispatch('financingReturnRules/filter', params)
          .then(this.getReturnRules);
      },

      scrollReturnRules() {
        const {
          scroller,
        } = this.$refs;

        if (this.limit || this.financingReturnRules.list.loading || !scroller) {
          return;
        }

        const top = (
          document.scrollingElement
          || document.documentElement
          || document.body
          || {}
        ).scrollTop;

        if (top && window.innerHeight + top >= scroller.$el.offsetHeight) {
          this.paginateReturnRules();
        }
      },

      paginateReturnRules() {
        const {
          page,
        } = this.financingReturnRules.list.filters;

        this.fetchReturnRules({
          page: page + 1,
          CRUDL_append: true,
        });
      },

      updateQuery() {
        if (this.$route.name !== 'settings-commercial-returns') {
          return;
        }

        const {
          per_page: perPage,
          active,
          CRUDL_append: crudl,
          ...filters
        } = this.financingReturnRules.list.filters;

        let query = {};
        query = findQueryParams(filters);

        this.$router.replace({
          name: 'settings-commercial-returns',
          query,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .returns-list-filters {
    margin: $gutter-smaller var(--product--pwa--horizontal);

    @media all and (min-width: $breakpoint-desktop) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }
</style>
